var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ir-generic-component-mobile",staticStyle:{"border":"0px solid"}},[_c('div',{staticClass:"mb-1",attrs:{"id":"headline-generic-component"}},[_c('h2',[_vm._v(_vm._s(_vm.getGenericPage.menu_display))])]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.getGenericPage.html_page)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }